import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionPrivate } from '../../store/auth';
import {Row, Column} from '../inspinia'


class Modulo extends React.PureComponent
{
    constructor(props)
    {
        super(props);

        document.body.style = 'background: #01bc8e;';
    }

    render()
    {
        
        return (
        <div>
        <img src="/assets/images/modulo/TelaModulo2.png" style={{"height": "100vh", "position": "absolute", "bottom": "0px", "right": "0px"}} />
            <div className="container">
                <Row style={{display: 'flex',  justifyContent:'center', alignItems: 'center', height: '90vh',width: '190vh' }}>
                    <div className="col">            
                        <img src="/assets/images/modulo/campanha.png" width="390" height="150"/>
                        <Column>
                            <Link to={c.DEFAULT_PRIVATE_ROUTE} className="btn btn-primary" style={{width: "55%", background: "#4cd4b2", border: "none"}} >Entrar</Link>
                        </Column>
                    </div>

                    <div className="col">            
                        <img src="/assets/images/modulo/carimbo-tempo.png" width="390" height="150"/>
                        <Column>
                                <Link to={c.CAMPAIGN_ROUTE + "/nova"} className="btn btn-primary" style={{width: "55%", background: "#fcb93d", border: "none"}} >Entrar</Link>
                        </Column> 
                    </div>
                </Row>
            </div>  
        </div>
        );
    }

}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { auth: bindActionCreators(authActionPrivate, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Modulo));
